import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect } from 'react';
import { ThemeProvider } from '@chegg-ui/theme';
import { FooterLegal } from '@chegg-me-components/footer-legal';
import { LanguageSelector } from '@chegg-me-components/language-selector';
import { NavigationDataType, useNavigationData } from '@chegg-me-components/navigation-data';
import { clickBaseEvent, initializeRioClient } from '@chegg-me-components/utils';
import PrimaryNav from '../components/PrimaryNav';
import { rioClient } from '../rio';
import { defaultContext, FooterContext, Footertheme, isNavLinkItem } from '../shared';
import { FooterShell, LegalLinksContainer } from '../styles/root';

var SignedInFooter = function SignedInFooter(_ref) {
  var _ref$navLinks = _ref.navLinks,
      navLinks = _ref$navLinks === void 0 ? [] : _ref$navLinks,
      _ref$legalLinks = _ref.legalLinks,
      legalLinks = _ref$legalLinks === void 0 ? [] : _ref$legalLinks,
      _ref$languageSelector = _ref.languageSelectorItems,
      languageSelectorItems = _ref$languageSelector === void 0 ? [] : _ref$languageSelector,
      legalNote = _ref.legalNote,
      envUrl = _ref.envUrl,
      className = _ref.className,
      dataTest = _ref['data-test'],
      rioConfig = _ref.rioConfig,
      clientEnv = _ref.clientEnv,
      locale = _ref.locale,
      _ref$useCache = _ref.useCache,
      useCache = _ref$useCache === void 0 ? true : _ref$useCache,
      _ref$isPreviewMode = _ref.isPreviewMode,
      isPreviewMode = _ref$isPreviewMode === void 0 ? false : _ref$isPreviewMode,
      accessToken = _ref.accessToken,
      _ref$showLangSelector = _ref.showLangSelector,
      showLangSelector = _ref$showLangSelector === void 0 ? false : _ref$showLangSelector,
      cookieDomain = _ref.cookieDomain,
      oneGraphClient = _ref.oneGraphClient,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? '' : _ref$countryCode;
  useEffect(function () {
    initializeRioClient(rioConfig);
  }, []);
  var skipQuery = navLinks.length > 0 && legalLinks.length > 0;
  var contextValue = {
    envUrl: envUrl,
    dataTestPrefix: dataTest !== null && dataTest !== void 0 ? dataTest : defaultContext.dataTestPrefix,
    cookieDomain: cookieDomain
  }; // Fetches data from bff call when skipQuery=false

  var _useNavigationData = useNavigationData({
    skipQuery: skipQuery,
    navigationDataType: NavigationDataType.SignedInFooter,
    clientEnv: clientEnv,
    locale: locale,
    useCache: useCache,
    isPreviewMode: isPreviewMode,
    accessToken: accessToken,
    oneGraphClient: oneGraphClient,
    countryCode: countryCode
  }),
      _useNavigationData$da = _useNavigationData.data,
      data = _useNavigationData$da === void 0 ? {} : _useNavigationData$da,
      isLoading = _useNavigationData.isLoading;

  var PrimaryNavLinks = data.PrimaryNav || navLinks;
  var LegalNavLinks = data.LegalNav || legalLinks;
  var languageSelector = data.LanguageSelector || {};
  var LegalNote = data.FooterLegalNote || legalNote;
  var navMenuItems = (skipQuery ? navLinks : PrimaryNavLinks).map(function (item) {
    if (!item.parent) return item;
    return _objectSpread({
      text: item.parent.text
    }, isNavLinkItem(item.parent) && {
      href: item.parent.href,
      target: item.parent.target,
      useAbsolute: item.parent.useAbsolute === true
    });
  });
  var parsedLegalNav = (skipQuery ? legalLinks : LegalNavLinks).map(function (item) {
    return item.parent || item;
  });
  var languageProps = skipQuery ? languageSelectorItems : languageSelector.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: Footertheme
  }, /*#__PURE__*/React.createElement(FooterContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(FooterShell, {
    className: className,
    "data-test": "".concat(contextValue.dataTestPrefix)
  }, /*#__PURE__*/React.createElement(PrimaryNav, {
    navLinks: navMenuItems.map(function (navLinkItem) {
      return _objectSpread({
        onClick:
        /* istanbul ignore next */
        function onClick(e) {
          var _navLinkItem$onClick;

          (_navLinkItem$onClick = navLinkItem.onClick) === null || _navLinkItem$onClick === void 0 ? void 0 : _navLinkItem$onClick.call(navLinkItem, e);
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            type: 'clickstream_interaction',
            data: {
              interaction: {
                type: 'click',
                element: {
                  name: 'footer menu item',
                  type: 'link',
                  region_name: 'footer',
                  text: navLinkItem.text
                }
              }
            }
          }));
        }
      }, navLinkItem);
    })
  }, showLangSelector && (languageProps === null || languageProps === void 0 ? void 0 : languageProps.length) > 0 ? /*#__PURE__*/React.createElement(LanguageSelector, {
    languageProps: languageProps,
    isFooter: true,
    cookieDomain: cookieDomain
  }) : undefined), /*#__PURE__*/React.createElement(LegalLinksContainer, {
    "data-test": "".concat(contextValue.dataTestPrefix, "-legal-links-container")
  }, !isLoading && /*#__PURE__*/React.createElement(FooterLegal, {
    legalLinks: parsedLegalNav.map(function (navLinkItem) {
      return _objectSpread({
        onClick:
        /* istanbul ignore next */
        function onClick(e) {
          var _navLinkItem$onClick2;

          (_navLinkItem$onClick2 = navLinkItem.onClick) === null || _navLinkItem$onClick2 === void 0 ? void 0 : _navLinkItem$onClick2.call(navLinkItem, e);
          rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
            type: 'clickstream_interaction',
            data: {
              interaction: {
                type: 'click',
                element: {
                  name: 'footer menu item',
                  type: 'link',
                  region_name: 'footer',
                  text: navLinkItem.text
                }
              }
            }
          }));
        }
      }, navLinkItem);
    }),
    envUrl: contextValue.envUrl,
    dataTestPrefix: contextValue.dataTestPrefix,
    legalNote: LegalNote
  })))));
};

SignedInFooter.displayName = 'SignedInFooter';
export default SignedInFooter;